import React from 'react';
import './AboutMe.css';

function AboutMe() {
  return (
    <section className="about-me" id="about">
      <div className="container">
        
        {/* <div className='h2-container'>
          <h2>{'>'} About Me</h2>
        </div> */}

        <div className="about-image">
            <img src="./lara-lopes.png" alt="profile-img" />
            {/* Social Links */}
          <div className="social-links">
            <a href="https://github.com/laraflopes" target="_blank" rel="noopener noreferrer">
              <img src="./github.png" alt="GitHub" className="social-icon"/>
            </a>
            <a href="https://www.linkedin.com/in/lara-lopes-content/" target="_blank" rel="noopener noreferrer">
              <img src="./linkedin.png" alt="LinkedIn" className="social-icon"/>
            </a>
          </div>
        </div>
        
        <div className="about-content">
          
          <div className="about-text">

          <ul className="skills-list">
              <li>HTML</li>
              <li>CSS</li>
              <li>JavaScript</li>
              <li>React</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>MySQL</li>
            </ul>

            <div className='about-p'>
               <p>{'>'} My coding journey began with a spark of genuine curiosity, leading me to web development and as a self-taught front-end developer, I bring a unique perspective to problem-solving and design.  Through independent study and practical project experience, I've built a strong foundation in both front-end and back-end technologies.</p>
               <br></br>
               <p>{'>'} When developing web applications, sites, and other digital solutions, I focus on creating ones that are not only functional and user-friendly but also aesthetically pleasing. All while ensuring my development is deeply rooted in best practices for scalability and maintainability.</p>
               <br></br>
               <p>{'>'} I am ready to apply my skills across a variety of projects. If you're looking for a developer who can quickly adapt and deliver quality results, I'd love to discuss how we can work together.</p>
            </div>

           
            <a href="mailto:laraflopescv@gmail.com" class="btn btn-outline-dark mt-3">Contact Me</a>
            <a href="./cv.pdf" className="btn">CV</a>

          </div>

          

        </div>
      </div>
    </section>
  );
}

export default AboutMe;
